<template>
  <v-row>
    <v-col cols="6">
      <span>{{ $t('address.sub_district') }}</span>
      <addressinput-subdistrict
        v-model="form.addressSubDistrict"
        @itemselect="changeValue"
        :inputClass="`grey lighten-4 px-2 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
        label=""
      />
    </v-col>
    <v-col cols="6">
      <span>{{ $t('address.district') }}</span>
      <addressinput-district
        @itemselect="changeValue"
        v-model="form.addressDistrict"
        :inputClass="`grey lighten-4 px-2 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
        label=""
      />
    </v-col>
    <v-col cols="6">
      <span>{{ $t('address.province') }}</span>
      <addressinput-province
        @itemselect="changeValue"
        v-model="form.addressProvince"
        :inputClass="`grey lighten-4 px-2 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
        label=""
      />
    </v-col>
    <v-col cols="6">
      <span>{{ $t('address.zipcode') }}</span>
      <addressinput-zipcode
        @itemselect="changeValue"
        v-model="form.addressZipcode"
        :inputClass="`grey lighten-4 px-2 py-3 rounded elevention-0 w-100 outline-none ${$helper.addressLocaleClass}`"
        label=""
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AddressComponent",
  created() {},
  data() {
    return {
      form: {
        addressStreet: "",
        addressSubcode: "",
        addressDistrict: "",
        addressProvince: "",
        addressZipcode: ""
      }
    };
  },
  props: {},
  methods: {
    changeValue() {
      this.$emit("onChange", this.form);
    }
  }
};
</script>

<style lang="scss" scoped></style>
